import React, { useState, useEffect } from "react";
import MonthPicker from "./MonthPicker";
import axiosInstance from "../networking/axiosconfig";

const CalenderView = ({ userId }) => {
  const [attendanceData, setAttendanceData] = useState({});
  const [selectedMonth, setSelectedMonth] = useState(() => {
    const today = new Date();
    return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}`;
  });

  const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const firstDayOfMonth = new Date(selectedMonth + "-01").getDay();
  // const lastDate = new Date(2025, parseInt(selectedMonth.split("-")[1]), 0).getDate();

  const [year, month] = selectedMonth.split("-").map(Number);
  const lastDate = new Date(year, month, 0).getDate();

  const formatWorkingHours = (totalMinutes) => {
    if (!totalMinutes || totalMinutes <= 0) return "0";

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${hours}h ${minutes}m`;
  };

  const statusMap = {
    1: "Present",
    2: "Absent",
    3: "Holiday",
    4: "Leave",
    5: "HolidayButPresent",
    6: "LeaveButPresent",
    7: "Weekend",
    8: "WeekendButPresent",
  };

  const statusClasses = {
    Present: "bg-green-200 text-green-800 border-green-600",
    Absent: "bg-red-200 text-red-800 border-red-600",
    Holiday: "bg-blue-200 text-blue-800 border-blue-600",
    Leave: "bg-purple-200 text-purple-800 border-purple-600",
    Weekend: "bg-yellow-200 text-yellow-800 border-yellow-600",

  };

  const statusClassesColour = {
    Present: "bg-green-200 text-green-800 border-green-600",
    Absent: "bg-red-200 text-red-800 border-red-600",
    Holiday: "bg-blue-200 text-blue-800 border-blue-600",
    Leave: "bg-purple-200 text-purple-800 border-purple-600",
    Weekend: "bg-yellow-200 text-yellow-800 border-yellow-600",
    WeekendButPresent: "bg-green-200 text-green-800 border-green-600",
    HolidayButPresent: "bg-green-200 text-green-800 border-green-600",
    LeaveButPresent: "bg-green-200 text-green-800 border-green-600",
  };

  useEffect(() => {
    if (userId) {
      fetchAttendance(userId, selectedMonth);
    }
  }, [userId, selectedMonth]);

  const fetchAttendance = async (userId, month) => {
    const startDate = `${month}-01`;
    const endDate = `${month}-${lastDate}`;
    try {
      const response = await axiosInstance.get(`/api/attendance/getattendanceListByDate`, {
        params: { userId, startdate: startDate, enddate: endDate },
      });

      if (response.data.status) {
        const formattedData = {};
        response.data.data[0].attendance.forEach((record) => {
          const day = new Date(record.date).getDate();
          formattedData[day] = {
            status: statusMap[record.status] || "Unknown",
            totalWorkingHours: record.total_working_hours || 0,
            manualMessage: record.manual_message || null,
          };
        });
        setAttendanceData(formattedData);
      } else {
        setAttendanceData({});
      }
    } catch (error) {
      console.error("Error fetching attendance:", error);
    }
  };
  let calendarRows = [];
  let row = [];
  let emptyCells = firstDayOfMonth;
  let dayCounter = 1;
  const today = new Date();

  for (let i = 0; i < 6; i++) {
    row = [];
    for (let j = 0; j < 7; j++) {
      if (emptyCells > 0) {
        row.push(<td key={`empty-${j}`} className="border w-20 h-36"></td>);
        emptyCells--;
      } else if (dayCounter <= lastDate) {
        const currentDate = new Date(`${selectedMonth}-${String(dayCounter).padStart(2, "0")}`);
        const attendance = attendanceData[dayCounter] || {};
        let { status, totalWorkingHours, manualMessage } = attendance;

        // if (currentDate > today) {
        //   row.push(<td key={dayCounter} className="border w-20 h-36 bg-gray-50"></td>);
        //   dayCounter++;
        //   continue;
        // }

        if (currentDate > today) {
          row.push(
            <td key={dayCounter} className="border w-20 h-36 bg-gray-100 text-center">
              <div className="flex flex-col w-full h-full p-2">
                <span className="font-semibold text-xl text-left w-full block">{dayCounter}</span>

              </div>
            </td>
          );
          dayCounter++;
          continue;
        }


        const dayOfWeek = j;

        if (!status) {
          if (dayOfWeek === 0) {
            status = "Weekend";
            totalWorkingHours = 0;
          } else {
            status = "Absent";
            totalWorkingHours = 0;
          }
        }

        if (status === "Present" && dayOfWeek === 0) {
          status = "WeekendButPresent";
        }

        const cellColor =
          status === "Holiday"
            ? "bg-blue-100"
            : status === "Leave"
              ? "bg-purple-100"
              : status === "Weekend"
                ? "bg-yellow-100"
                : status === "WeekendButPresent"
                  ? "bg-green-100"
                  : status === "HolidayButPresent"
                    ? "bg-blue-100"
                    : status === "LeaveButPresent"
                      ? "bg-purple-100"
                      : status === "Absent"
                        ? "bg-red-100"
                        : "bg-gray-100";

        row.push(
          <td key={dayCounter} className={`border w-20 h-36 text-center relative group ${cellColor}`}>
            <div className="flex flex-col w-full h-full p-2">
              <div className="flex justify-between w-full">
                <span className="font-semibold text-xl text-left block">{dayCounter}</span>
                {manualMessage && (
                  <div className="relative flex items-center justify-center">
                    <span className="w-3 h-3 bg-red-500 rounded-full cursor-pointer animate-pulse"></span>
                    <div className="absolute right-0 top-6 w-48 bg-gray-800 text-white text-xs rounded opacity-0 invisible group-hover:visible group-hover:opacity-100 transition-opacity duration-300 z-10 p-2 shadow-lg">
                      {manualMessage}
                    </div>
                  </div>
                )}
              </div>

              {status && (
                <div className="flex flex-col items-center justify-center mt-4">
                  <span
                    className={`text-base px-8 py-2 rounded-md shadow border-l-4 ${statusClassesColour[status] || "bg-gray-200 text-gray-800 border-gray-600"
                      }`}
                  >
                    {(() => {
                      switch (status) {
                        case "WeekendButPresent":
                        case "HolidayButPresent":
                        case "LeaveButPresent":
                          return "Present";
                        default:
                          return status;
                      }
                    })()}
                  </span>

                  <div className="flex flex-col items-end w-full">
                    <span className="text-sm mt-10 text-black px-2 py-1 rounded">
                      {totalWorkingHours !== undefined
                        ? `TWH: ${formatWorkingHours(totalWorkingHours)}`
                        : "TWH: 0"}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </td>
        );

        dayCounter++;
      } else {
        row.push(<td key={`empty-end-${j}`} className="border w-20 h-20"></td>);
      }
    }
    calendarRows.push(<tr key={i}>{row}</tr>);
    if (dayCounter > lastDate) break;
  }



  const legendItems = Object.entries(statusClasses).map(([status, color]) => (
    <div key={status} className="flex items-center space-x-2">
      <span className={`w-4 h-4 inline-block rounded ${color.split(" ")[0]}`}></span>
      <span className="text-sm font-medium">{status}</span>
    </div>
  ));


  return (
    <div className="mx-auto h-auto  rounded-lg shadow-lg">
      {/* Legend Section - Centered */}
      <div className="flex space-x-4 justify-center ">
        <MonthPicker selectedMonth={selectedMonth} setSelectedMonth={setSelectedMonth} />
      </div>
      <div className="mb-2 text-right pr-4">
        <h1 className="text-sm font-semibold py-3">TWH = Total Working Hours</h1>
        <div className="flex flex-wrap justify-end gap-4">{legendItems}</div>
      </div>
      <table className="table-fixed w-full border-collapse border text-left">
        <thead>
          <tr className="bg-slate-100">
            {daysOfWeek.map((day, index) => (
              <th key={index} className="border w-10 h-10 text-center">
                {day}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{calendarRows}</tbody>
      </table>
    </div>
  );
};

export default CalenderView;
